/**
 * Length caps on the free-text invoice fields. Each mirrors the `max_length` of the matching request field in
 * `app/money/invoice/invoice_validators.py` (the backend is the authority and rejects longer input with a 400);
 * the forms use them for `maxlength` and validation so an overlong value is stopped in the browser instead.
 */

/** `PAYMENT_HEADER_MAX_LENGTH` in `app/money/invoice/payment_header_service.py`. */
export const PAYMENT_HEADER_MAX_LENGTH = 1000;

/** `Invoice.reference` is a `String(128)` column. */
export const INVOICE_REFERENCE_MAX_LENGTH = 128;

/**
 * Buyer sales invoice fields. The name goes to Merit Aktiva as `Customer.Name`, capped at 150
 * (`MERIT_CUSTOMER_NAME_MAX_LENGTH` in `app/money/invoice/invoice_utils.py`); the rest are sized to the
 * `GlobalCompany` columns the form is prefilled from.
 */
export const BUYER_NAME_MAX_LENGTH = 150;
export const BUYER_ADDRESS_MAX_LENGTH = 512;
export const BUYER_REGISTRY_CODE_MAX_LENGTH = 128;
export const BUYER_VAT_MAX_LENGTH = 128;
